import { FiEye } from "react-icons/fi";
import React, { useState } from "react";
import {
  CardWrapper,
  ThreeDotsContainer,
  UpdateIcon,
  DeleteIcon,
  Eye,
} from "./style";
import { FiMoreVertical } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import img from "../../../assets/icons/calendard.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus-icon.svg";

function CategoryCard({
  data,
  onDelete,
  onEdit,
  onclick,
  rezume,
  achive,
  noaction,
  handleNum,
}) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <CardWrapper>
        <div className="card-header">
          <h2 className="title truncate-text">{data.title}</h2>
          <div className="header">
            <FiMoreVertical
              className="three-dots"
              onClick={() => (open ? setOpen(false) : setOpen(true))}
            />
          </div>

          {noaction ? null : (
            <>
              {open && (
                <ThreeDotsContainer
                  rezume={rezume}
                  onMouseOver={() => setOpen(true)}
                  onMouseOut={() => setOpen(false)}
                >
                  {achive ? (
                    <UpdateIcon onClick={() => onEdit(data)}>
                      <FiEdit size={13} className="editicon" />
                      Arxivlash
                    </UpdateIcon>
                  ) : (
                    <>
                      {rezume ? (
                        <Eye onClick={onclick}>
                          <FiEye size={14} className="delicon" /> Ko‘rish{" "}
                        </Eye>
                      ) : null}
                      <UpdateIcon onClick={() => onEdit(data)}>
                        <FiEdit size={13} className="editicon" />
                        Tahrirlash
                      </UpdateIcon>
                      <DeleteIcon onClick={() => onDelete(data.id)}>
                        <FiTrash2 size={14} className="delicon" /> O’chirish
                      </DeleteIcon>
                    </>
                  )}
                </ThreeDotsContainer>
              )}
            </>
          )}
        </div>
        {data.date ? (
          <>
            <div className="footer">
              <div className="foterNum">
                <h1 className="num">{data.count}</h1>
                <p className="nafar">nafar</p>
              </div>
              <h3 className="date">
                <img src={img} alt="" />
                {data.date}
              </h3>
            </div>
          </>
        ) : (
          <div className="num-and-plus">
            <h1 className="num">{data.count}</h1>

            <PlusIcon
              className="plus"
              onClick={() => {
                handleNum(data.id);
              }}
            />
          </div>
        )}
      </CardWrapper>
    </div>
  );
}

export default CategoryCard;
